import { useIntl } from 'react-intl';

export default function useTranslate(): Function {
  return useIntl().formatMessage;
}
